import React from 'react';
import { css } from '@emotion/core';
import i18n from 'i18next';
import Divider from '@material-ui/core/Divider';

import Button from 'Mui/Button';
import { line, system300 } from 'Mui/styles/color';
import useLoginUrl from 'client/hooks/login/useLoginUrl';
import useLoginLinkClickAction from 'client/hooks/login/useLoginLinkAction';
import { loginTypesForApi } from 'config/loginTypes';

function LoginLine() {
    const loginUrl = useLoginUrl({ loginType: loginTypesForApi.LINE });
    const { target, href, onClick } = useLoginLinkClickAction({ loginUrl });

    return (
        <a href={href} target={target} onClick={onClick} css={linkStyle}>
            <Button css={[buttonStyle]}>
                <span css={iconStyle} />
                <Divider css={dividerStyle} orientation="vertical" flexItem />
                {i18n.t('label.login.line_auth_login')}
            </Button>
        </a>
    );
}

export default LoginLine;

const buttonStyle = css`
    color: #fff;
    border-radius: 8px;
    background-color: ${line.color};
    padding: 6px 6.5px;
    font-weight: bold;
    padding-left: 5px;
    &:hover {
        background-color: ${line.color};
    }
    &.Mui-disabled {
        background-color: ${system300.color};
        color: #fff;
    }
`;

const linkStyle = css`
    text-decoration: none;
`;

const iconStyle = css`
    height: 24px;
    width: 24px;
    display: block;
    background: url(https://assets.fevercdn.com/promotion/img/icon-line-login.png) 50% 50% no-repeat;
    background-size: contain;
`;

const dividerStyle = css`
    margin: -6px 5px;
`;
